import { useEffect } from "react";
import * as Image from "../../assets/images";
import { ContentPotato } from "../../assets/images";

import { useTranslation } from "react-i18next";

import { translateKey } from '../../utility';


const ids = [
  JSON.parse((translateKey("1"))),
  JSON.parse((translateKey("2"))),
  JSON.parse((translateKey("3"))),
  JSON.parse((translateKey("4"))),
  JSON.parse((translateKey("5"))),
  JSON.parse((translateKey("6")))
]

const idsCat = [
  JSON.parse((translateKey("Cat_1"))),
  JSON.parse((translateKey("Cat_2"))),
  JSON.parse((translateKey("Cat_3"))),
  JSON.parse((translateKey("Cat_4"))),
  JSON.parse((translateKey("Cat_5"))),
  JSON.parse((translateKey("Cat_6")))
]


const petFood = [
  {
    id: 1,
    ...ids[0],
    src: Image.ChickenPoster,
    ingredientSrc: [
      Image.ContentChicken,
      ContentPotato,
      Image.ContentBeans,
      Image.ContentZucchini,
      Image.ContentApple,
      Image.ContentCarrot,
    ],
  },
  {
    id: 2,
    ...ids[1],
    src: Image.TurkeyPoster,
    ingredientSrc: [
      Image.ContentTurkey,
      ContentPotato,
      ,
      Image.ContentBeans,
      Image.ContentZucchini,
      Image.ContentApple,
      Image.ContentCarrot,
    ],
  },
  {
    id: 3,
    ...ids[2],
    src: Image.SomonPoster,
    ingredientSrc: [
      Image.ContentSalmon,
      ContentPotato,
      ,
      Image.ContentBeans,
      Image.ContentPumpkin,
      Image.ContentApple,
      Image.ContentCarrot,
    ],
  },
  {
    id: 4,
    ...ids[3],
    src: Image.BeffPoster,
    ingredientSrc: [
      Image.ContentBeef,
      ContentPotato,
      ,
      Image.ContentBeans,
      Image.ContentPumpkin,
      Image.ContentApple,
      Image.ContentCarrot,
    ],
  },
  {
    id: 5,
    ...ids[4],
    src: Image.LambPoster,
    ingredientSrc: [
      Image.ContentLamb,
      ContentPotato,
      ,
      Image.ContentBeans,
      Image.ContentPumpkin,
      Image.ContentApple,
      Image.ContentCarrot,
    ],
  },
  {
    id: 6,
    ...ids[5],
    src: Image.LavrekPoster,
    ingredientSrc: [
      Image.ContentSeabass,
      ContentPotato,
      ,
      Image.ContentBeans,
      Image.ContentPumpkin,
      Image.ContentApple,
      Image.ContentCarrot,
    ],
  },
];

const catPetFood = [
  {
    id: 1,
    ...idsCat[0],
    src: Image.ChickenPosterCat,
    ingredientSrc: [
      Image.ContentChicken,
      ContentPotato,
      Image.ContentBeans,
      Image.ContentZucchini,
      Image.ContentApple,
      Image.ContentCarrot,
    ],
  },
  {
    id: 2,
    ...idsCat[1],
    src: Image.TurkeyPosterCat,
    ingredientSrc: [
      Image.ContentTurkey,
      ContentPotato,
      ,
      Image.ContentBeans,
      Image.ContentZucchini,
      Image.ContentApple,
      Image.ContentCarrot,
    ],
  },
  {
    id: 3,
    ...idsCat[2],
    src: Image.SomonPosterCat,
    ingredientSrc: [
      Image.ContentSalmon,
      ContentPotato,
      ,
      Image.ContentBeans,
      Image.ContentPumpkin,
      Image.ContentApple,
      Image.ContentCarrot,
    ],
  },
  {
    id: 4,
    ...idsCat[3],
    src: Image.BeffPosterCat,
    ingredientSrc: [
      Image.ContentBeef,
      ContentPotato,
      ,
      Image.ContentBeans,
      Image.ContentPumpkin,
      Image.ContentApple,
      Image.ContentCarrot,
    ],
  },
  {
    id: 5,
    ...idsCat[4],
    src: Image.LambPosterCat,
    ingredientSrc: [
      Image.ContentLamb,
      ContentPotato,
      ,
      Image.ContentBeans,
      Image.ContentPumpkin,
      Image.ContentApple,
      Image.ContentCarrot,
    ],
  },
  {
    id: 6,
    ...idsCat[5],
    src: Image.TonPosterCat,
    ingredientSrc: [
      Image.ContentSeabass,
      ContentPotato,
      ,
      Image.ContentBeans,
      Image.ContentPumpkin,
      Image.ContentApple,
      Image.ContentCarrot,
    ],
  },
];


function PetFoodSelection({ petInfo, setPetInfo, setIsComplete, petType }) {
  const { t } = useTranslation();

  const addFood = (food) => {
    if (petInfo.food.includes(food)) {
      setPetInfo({
        ...petInfo,
        food: petInfo.food.filter((f) => f !== food),
      });
    } else {
      setPetInfo({
        ...petInfo,
        food: [food],
      });
    }
    /*
     else if (
      (food.value === "lamb" && petInfo.food.find((f) => f.value == "calf")) ||
      (petInfo.food.find((f) => f.value == "lamb") && food.value === "calf")
    ) {
      console.log("lamb and calf");
      setPetInfo({
        ...petInfo,
        food: [...petInfo.food, food],
      });
    }
     */
  };

  useEffect(() => {
    petInfo.food.length > 0 ? setIsComplete(true) : setIsComplete(false);
  }, [petInfo]);

  return (
    <div className=" md:h-8/10 w-12/12 max-w-3xl mx-4 mt-4 mb-8 sm:mt-0 flex flex-col justify-center items-center">
      <div className="pt-0 sm:pt-8 pb-4 lg:pb-8">
        <div className="font-poppins text-lg text-yellow-700 font-bold lg:text-2xl">
          {t("finalStep")},
        </div>
        <div className="font-poppins mx-4 text-yellow-600 text-xs lg:text-base">
          {t("chooseMealType")}
        </div>
      </div>
      <div className="relative grid grid-cols-2 gap-4 sm:grid-cols-3">
        {petType == 'dog' ? (petFood.map((food) => (
          // <div
          //   onClick={() => addFood(food)}
          //   key={food.id}
          //   className={`${
          //     petInfo.food.includes(food)
          //       ? "ring-2 ring-offset-2 ring-lime-600 border-lime-300"
          //       : "border-yellow-500"
          //   } relative rounded-lg border bg-white px-6 py-5 shadow-sm flex items-center space-x-3`}
          // >
          //   <div className="flex-shrink-0">
          //     <img
          //       className="h-10 w-10 rounded-full"
          //       src={
          //         "https://kitopet.studiofiftysix.co/wp-content/uploads/2022/04/kito-kopek-ikon-430x430.png"
          //       }
          //       alt=""
          //     />
          //   </div>
          //   <div className="flex-1 min-w-0">
          //     <a href="#" className="focus:outline-none">
          //       <span className="absolute inset-0" aria-hidden="true" />
          //       <p className="text-sm font-medium text-yellow-600">
          //         {food.name}
          //       </p>
          //       {petInfo.allergies.includes(food.value) ? (
          //         <div className="h-5 w-5 absolute top-1 right-1 text-xs font-small text-red-500">
          //           <ExclamationIcon aria-hidden="true" />
          //         </div>
          //       ) : null}
          //     </a>
          //   </div>
          // </div>
          <div key={food.id} className="flex-col items-baseline justify-center"
            onClick={() => addFood(food)}>

            <div className="flex justify-center">
              <img
                className={`w-full mb-2 mt-2 scale-[130%] -z-10`}
                src={food.src}
                alt={food.name}
              />
              {/* {food.svg} */}
            </div>
            <button
              type="button"
              className={`inline-flex items-center px-4 text-base py-2 border shadow-sm  font-medium rounded-lg -mt-10 z-10 
                    ${
                      petInfo.food.includes(food)
                        ? "bg-lime-600 border-transparent text-white hover:bg-lime-700"
                        : "bg-white border-yellow-200 text-yellow-800 hover:bg-yellow-50"
                    }`}
            >
              {food.name}
            </button>
          </div>
        ))) :  (catPetFood.map((food) => (
          <div key={food.id} className="flex-col items-baseline justify-center"
            onClick={() => addFood(food)}>

            <div className="flex justify-center">
              <img
                className={`w-full mb-2 mt-2 scale-[130%] -z-10`}
                src={food.src}
                alt={food.name}
              />
              {/* {food.svg} */}
            </div>
            <button
              type="button"
              className={`inline-flex items-center px-4 text-base py-2 border shadow-sm  font-medium rounded-lg -mt-10 z-10 
                    ${
                      petInfo.food.includes(food)
                        ? "bg-lime-600 border-transparent text-white hover:bg-lime-700"
                        : "bg-white border-yellow-200 text-yellow-800 hover:bg-yellow-50"
                    }`}
            >
              {food.name}
            </button>
          </div>
        )))}
      </div>
    </div>
  );
}

export default PetFoodSelection;
